import {FilterItemValue} from "./FilterItemValue";

export class FilterItem {

  public label: string;

  public filterLabel: string;

  public values: Array<FilterItemValue>;

  public expanded: boolean;


  constructor(label: string, filterLabel: string, values: Array<FilterItemValue>) {
    this.label = label;
    this.filterLabel = filterLabel;
    this.values = values;
    this.expanded = false;
  }
}



// WEBPACK FOOTER //
// ./src/models/FilterItem.ts